import AsusLogo from "../Assets/Logo/AsusLogo.png";
import JBLLogo from "../Assets/Logo/JBLLogo.jpg";
import HPLogo from "../Assets/Logo/HPLogo.png";
import DysonLogo from "../Assets/Logo/DysonLogo.png";
import LenovoLogo from "../Assets/Logo/LenovoLogo.jpg";
import LogitechLogo from "../Assets/Logo/LogitechLogo.png";
import XboxLogo from "../Assets/Logo/XboxLogo.png";
import SonyLogo from "../Assets/Logo/SonyLogo.jpeg";
import PlayStationLogo from "../Assets/Logo/PlayStationLogo.png";
import PnyLogo from "../Assets/Logo/PnyLogo.png";
import MSILogo from "../Assets/Logo/MSI-Logo.png";
import NintendoLogo from "../Assets/Logo/NintendoLogo.jpg";
import AMDLogo from "../Assets/Logo/AMDLogo.png";
import AcerLogo from "../Assets/Logo/AcerLogo.png";
import AppleLogo from "../Assets/Logo/AppleLogo.png";
import DellLogo from "../Assets/Logo/DellLogo.png";
import HarmonKardonLogo from "../Assets/Logo/HarmonKardonLogo.png";
import IntelLogo from "../Assets/Logo/IntelLogo.jpg";
import NvidiaLogo from "../Assets/Logo/NvidiaLogo.png";
import ToshibaLogo from "../Assets/Logo/ToshibaLogo.jpeg";
import BoseLogo from "../Assets/Logo/BoseLogo.png";
import AlienWareLogo from "../Assets/Logo/AlienwareLogo.png";
import DJILogo from '../Assets/Logo/DJILogo.png'


export const Logo = [
  { id: 1, image: JBLLogo, className: "h-20 object-contain z-10" },
  { id: 2, image: AsusLogo, className: "h-10 object-contain z-10" },
  { id: 3, image: HPLogo, className: "h-20 object-contain z-10" },
  { id: 4, image: DysonLogo, className: "h-16 object-contain z-10" },
  { id: 5, image: LenovoLogo, className: "h-20 object-contain z-10" },
  { id: 6, image: LogitechLogo, className: "h-10 object-contain z-10" },
  { id: 7, image: XboxLogo, className: "h-14 object-contain z-10" },
  { id: 8, image: SonyLogo, className: "h-20 object-contain z-10" },
  { id: 9, image: AppleLogo, className: "h-16 object-contain z-10" },
  { id: 10, image: PlayStationLogo, className: "h-16 object-contain z-10" },
  { id: 11, image: NintendoLogo, className: "h-20 object-contain z-10" },
  { id: 12, image: PnyLogo, className: "h-6 object-contain z-10" },
  { id: 13, image: MSILogo, className: "h-16 object-contain z-10" },
  { id: 14, image: DJILogo, className: "h-24 object-contain z-10" },
  { id: 15, image: AMDLogo, className: "h-12 object-contain z-10" },
  { id: 16, image: AcerLogo, className: "h-12 object-contain z-10" },
  { id: 17, image: HarmonKardonLogo, className: "h-7 object-contain z-10" },
  { id: 18, image: IntelLogo, className: "h-20 object-contain z-10" },
  { id: 19, image: ToshibaLogo, className: "h-20 object-contain z-10" },
  { id: 20, image: DellLogo, className: "h-28 object-contain z-10" },
  { id: 21, image: BoseLogo, className: "h-20 object-contain z-10" },
  { id: 22, image: NvidiaLogo, className: "h-7 object-contain z-10" },
  { id: 23, image: AlienWareLogo, className: "h-24 object-contain z-10" },
];
